/**
 * API base URL for backend requests.
 * Use this so cart/place-order and other API calls work on live/E2E when
 * REACT_APP_API_URL is not set at build time (e.g. same-origin or injected).
 *
 * Priority:
 * 1. process.env.REACT_APP_SALON_API_URL (build-time, salon-specific)
 * 2. process.env.REACT_APP_API_URL (build-time, shared)
 * 3. window.NYAFAZ_SALON_API_URL (injected, salon-specific)
 * 4. window.NYAFAZ_API_URL (injected, shared)
 * 5. window.REACT_APP_SALON_API_URL (injected, salon-specific)
 * 6. window.REACT_APP_API_URL (injected, shared)
 * 7. Dev fallback: when app is on localhost:3000, use localhost:5002 (salon backend)
 * 8. window.location.origin (same-origin when app and API are on same host)
 */
const DEFAULT_DEV_API_ORIGIN = 'http://localhost:5002';

export function getApiBaseUrl() {
  const fromSalonEnv = typeof process !== 'undefined' && process.env && process.env.REACT_APP_SALON_API_URL;
  if (fromSalonEnv && String(fromSalonEnv).trim()) return String(fromSalonEnv).trim().replace(/\/$/, '');

  const fromEnv = typeof process !== 'undefined' && process.env && process.env.REACT_APP_API_URL;
  const normalizedFromEnv = fromEnv && String(fromEnv).trim() ? String(fromEnv).trim().replace(/\/$/, '') : '';

  if (typeof window !== 'undefined') {
    const fromWindow =
      window.NYAFAZ_SALON_API_URL ||
      window.NYAFAZ_API_URL ||
      window.REACT_APP_SALON_API_URL ||
      window.REACT_APP_API_URL;
    if (fromWindow && String(fromWindow).trim()) return String(fromWindow).trim().replace(/\/$/, '');

    const origin = window.location && window.location.origin;
    if (origin && (origin === 'http://localhost:3000' || origin === 'https://localhost:3000')) {
      // Shared API URL is often configured for legacy monolith (5000); salon runs on 5002.
      if (normalizedFromEnv === 'http://localhost:5000' || normalizedFromEnv === 'https://localhost:5000') {
        return DEFAULT_DEV_API_ORIGIN;
      }
      if (normalizedFromEnv) return normalizedFromEnv;
      return DEFAULT_DEV_API_ORIGIN;
    }

    if (origin && /analyze\.nyafaz\.com$/i.test(new URL(origin).hostname)) {
      return origin;
    }

    if (normalizedFromEnv) return normalizedFromEnv;
    if (origin) return origin;
  }

  if (normalizedFromEnv) return normalizedFromEnv;

  return '';
}

/** Salon frontend: Flask blueprints are mounted under `/api/salon/*` (see backend/salon). */
export const SALON_API_PREFIX = '/api/salon';
